module.exports = " <div class=boxed-header> <span class=repo-tree>Repository Tree</span> <button type=button class=\"btn btn-sm btn-primary right\" tooltip=\"{{ copyTooltip }}\" v-clipboard:copy=repoTree :disabled=isDisabled @click=\"copyTooltip = 'Copied'\">Copy to clipboard</button> </div> <div class=boxed-content> <pre class=form-control>{{{ repoTree }}}</pre> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tree.vue
 ** module id = 131
 ** module chunks = 0
 **/